import ButtonGroup from '@mui/material/ButtonGroup';
import React from 'react';

const ButtonGroupWidget = ({ children }: any) => {
  return (
    <ButtonGroup variant="contained" color="primary">
      {children}
    </ButtonGroup>
  );
};

export default ButtonGroupWidget;
